import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { AuthRoute } from '../auth/guards/auth-route';
import { NotificationsPage } from './notifications-page';
import { NotificationSettingsPage } from './subscriptions/notification-settings-page';
import { ActiveWorkspaceProvider } from '../workspace/active-workspace-id-context';
export const NotificationRoutes = (_jsxs(Fragment, { children: [_jsx(Route, { path: "/notifications", element: _jsx(AuthRoute, { children: _jsx(ActiveWorkspaceProvider, { children: _jsx(NotificationsPage, {}) }) }) }), _jsx(Route, { path: "/notifications/settings", element: _jsx(AuthRoute, { children: _jsx(NotificationSettingsPage, {}) }) })] }));
